export const ZIPCODE_CHANGE = 'ZIPCODE_CHANGE';